import React from 'react'

import Dialog from 'components/Dialog'

import ConsentPromptContent from '../ConsentPromptContent'

import Styles from './styles.scss'


export default function Modal() {
  return (
    <Dialog
      uiType="consent-banner"
    >
      <ConsentPromptContent
        stylesOverrides={ Styles }
      />
    </Dialog>
  )
}
